import { VITE_SOLANA_RPC_ENDPOINT } from '@/env'
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react'
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui'
import '@solana/wallet-adapter-react-ui/styles.css'
import {
  Coin98WalletAdapter,
  CoinbaseWalletAdapter,
  PhantomWalletAdapter,
  SolflareWalletAdapter,
  SolongWalletAdapter,
  TrustWalletAdapter
} from '@solana/wallet-adapter-wallets'
import { PropsWithChildren, useMemo } from 'react'
import { SolPriceProvider } from './SOLPriceProvider'
import { ValidatorAPYProvider } from './ValidatorAPYContext'

export const SolanaWalletProvider = ({ children }: PropsWithChildren) => {
  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter(),
      new CoinbaseWalletAdapter(),
      new SolongWalletAdapter(),
      new TrustWalletAdapter(),
      new Coin98WalletAdapter()
    ],
    []
  )

  return (
    <ConnectionProvider endpoint={VITE_SOLANA_RPC_ENDPOINT || ''}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <SolPriceProvider>
            <ValidatorAPYProvider>{children}</ValidatorAPYProvider>
          </SolPriceProvider>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  )
}
